import { singleton } from 'tsyringe';
import { OWGames } from '../../odk-ts';
import { IOwGamesWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-games-wrapper.interface';
import { RunningGameInfo } from '../../odk-ts/type-aliases';

// -----------------------------------------------------------------------------
@singleton()
export class OWGamesWrapper implements IOwGamesWrapper {
  // ---------------------------------------------------------------------------
  public async getRunningGameInfo(): Promise<RunningGameInfo> {
    return OWGames.getRunningGameInfo();
  }

  // ---------------------------------------------------------------------------
  public async getGameDBInfo(gameId: number): Promise<any> {
    return OWGames.getGameDBInfo(gameId);
  }
}
